import React, { useEffect, useState } from "react";
import { AllTabType, IAddressData } from "src/types/GlobalInterfaces";
import ManageAddressSection from "./ManageAddress/ManageAddressSection";
import AddNewAddressSection from "./ManageAddress/AddNewAddressSection";
import AddressFormSection from "./ManageAddress/AddressFormSection";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";

interface IProps {
  setActiveTab?: (tab: AllTabType) => void;
  onBack?: () => void;
  onSelectAddress?: (address: IAddressData | null) => void;
  directBack?: boolean;
  onClose?: () => void;
}

const ManageAddressScreen = ({
  setActiveTab,
  onBack,
  onSelectAddress,
  directBack = false,
  onClose,
}: IProps) => {
  const [acTab, setAcTab] = useState<AllTabType>("ManageAddress");

  const [isEditAddress, setIsEditAddress] = useState<boolean>(false);
  const [pickAddress, setPickAddress] = useState<any>(null);
  const { isLogged } = useSelector((state: RootState) => state.appReducer);

  const [addresses, setAddresses] = useState<IAddressData[]>([]);
  const [getLoader, setGetLoader] = useState<boolean>(false);

  const fetchAllAddresses = async () => {
    if (!isLogged) return;
    setGetLoader(true);
    const { res, err } = await httpRequest<{ data: IAddressData[] | null }>({
      path: "/customer-address/get-customer-addresss",
    });
    if (res) {
      setAddresses(res?.data || []);
    } else {
      toast(err, { type: "error" });
    }
    setGetLoader(false);
  };

  useEffect(() => {
    if (isLogged && acTab === "ManageAddress") {
      fetchAllAddresses();
    }
    if (!isLogged) {
      setAcTab("AddNewAddress");
    }
  }, [isLogged , acTab]);

  return (
    <>
      {acTab === "ManageAddress" && (
        <ManageAddressSection
          setActiveTab={setAcTab}
          onBack={onBack}
          onSelectAddress={onSelectAddress}
          setIsEditAddress={setIsEditAddress}
          setPickAddress={setPickAddress}
          addresses={addresses}
          getLoader={getLoader}
          onReload={() => {
            fetchAllAddresses();
          }}
        />
      )}
      {acTab === "AddNewAddress" && (
        <AddNewAddressSection
          setActiveTab={setAcTab}
          onBack={() => {
            if (isLogged) {
              setAcTab("ManageAddress");
            } else {
              onBack?.();
            }
          }}
          setPickAddress={(address) => {
            setPickAddress(address);
            setAcTab("AddressForm");
          }}
        />
      )}
      {acTab === "AddressForm" && (
        <AddressFormSection
          setActiveTab={setAcTab}
          onBack={() => {
            if (isLogged) {
              if (isEditAddress) {
                setAcTab("ManageAddress");
              } else {
                setAcTab("AddNewAddress");
              }
            } else {
              onBack?.();
            }
          }}
          setPickAddress={setPickAddress}
          pickAddress={pickAddress}
          setIsEditAddress={setIsEditAddress}
          isEditAddress={isEditAddress}
          onSuccess={() => {
            if (directBack) {
              onBack?.();
            }
          }}
        />
      )}
    </>
  );
};

export default ManageAddressScreen;
